import { useEffect, useRef, useState } from "react";
import { heroImage, brandName } from "@/mocks/gossip";

export default function Hero() {
  const [online, setOnline] = useState(28641);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setOnline((v) => v + Math.floor(Math.random() * 8));
    }, 1600);
    return () => clearInterval(timer);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const target = document.querySelector("#feed");
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative flex min-h-[92vh] w-full items-center overflow-hidden">
      <img
        src={heroImage}
        alt="吃瓜m 在线围观一起吃瓜的社区氛围插画"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/30 to-background-50" />

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 pb-16 pt-32 text-center md:px-6">
        <div className="mb-6 inline-flex flex-wrap items-center justify-center gap-2">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1.5 text-sm font-semibold text-accent-800">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600" />
            </span>
            实时在线
          </span>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/80 px-3 py-1.5 text-sm font-semibold text-primary-600 backdrop-blur">
            <i className="ri-user-heart-line text-base" aria-hidden="true" />
            {online.toLocaleString()} 位瓜友正在围观
          </span>
        </div>

        <h1 className="mx-auto max-w-3xl text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-6xl">
          吃瓜不孤单，点开
          <span className="mx-1 inline-flex -skew-x-6 rounded-xl bg-primary-500 px-3 py-0.5 align-middle text-background-50">
            吃瓜m
          </span>
          就能一起吃瓜
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
          在线围观、评论区见、聊瓜唠嗑、瓜团讨论，各路瓜友实时在线，边看边聊，越唠瓜越香。无论热点还是日常，总有同频的人正在等你搭话。
        </p>

        <form
          onSubmit={submitSearch}
          className="mx-auto mt-8 flex max-w-xl flex-col items-stretch gap-3 sm:flex-row sm:items-center"
        >
          <label className="relative flex-1">
            <span className="sr-only">搜索想围观的热瓜话题</span>
            <i
              className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-500"
              aria-hidden="true"
            />
            <input
              ref={inputRef}
              type="search"
              placeholder="搜一搜最近想围观的热瓜话题…"
              className="w-full rounded-full border border-background-300 bg-background-50/90 py-3 pl-11 pr-4 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-accent-400 focus:ring-2 focus:ring-accent-300/50 backdrop-blur"
            />
          </label>
          <button
            type="submit"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-flashlight-fill text-base" aria-hidden="true" />
            开吃
          </button>
        </form>

        <div className="mx-auto mt-9 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm">
          <span className="inline-flex items-center gap-2 text-foreground-700">
            <i className="ri-checkbox-circle-line text-accent-600" aria-hidden="true" />
            围观不收费
          </span>
          <span className="inline-flex items-center gap-2 text-foreground-700">
            <i className="ri-checkbox-circle-line text-accent-600" aria-hidden="true" />
            评论区畅聊
          </span>
          <span className="inline-flex items-center gap-2 text-foreground-700">
            <i className="ri-checkbox-circle-line text-accent-600" aria-hidden="true" />
            瓜团随时入
          </span>
        </div>

        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-3 gap-3 md:gap-4">
          {[
            { num: "128万+", label: "注册瓜友", icon: "ri-user-3-line" },
            { num: "24小时", label: "热瓜不打烊", icon: "ri-time-line" },
            { num: "9.2分", label: "吃瓜氛围口碑", icon: "ri-heart-3-line" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-background-200/70 bg-background-50/70 px-3 py-4 backdrop-blur"
            >
              <i className={`${s.icon} mx-auto mb-2 block text-xl text-accent-600`} aria-hidden="true" />
              <p className="text-lg font-extrabold text-foreground-950 md:text-2xl">{s.num}</p>
              <p className="mt-0.5 text-xs text-foreground-600 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="pointer-events-none absolute bottom-5 left-1/2 z-10 hidden -translate-x-1/2 md:block">
        <i className="ri-arrow-down-line animate-bounce text-xl text-primary-600" aria-hidden="true" />
      </div>
    </section>
  );
}